export default __webpack_public_path__ + "static/media/postcard-image.e873814d.png";